<template>
  <div class="pa-6 bg-custom">
    <h2 class="mb-4">
      {{ $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveHeader') }}
    </h2>
    <div>
      <div>
        <v-sheet color="white">
          <v-row class="px-5">
            <v-col lg="3" md="3" cols="12">
              <p
                class="title-live mb-0 font-weight-medium grey--text subtitle-2"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.searchLiveName'
                  )
                }}
              </p>
              <div class="xs-full-width">
                <v-text-field
                  outlined
                  hide-details="auto"
                  class="search-input"
                  v-model="searchdata"
                  @change="searchInfo(searchdata)"
                  :placeholder="
                    $vuetify.lang.t('$vuetify.courseManagement.liveStep.search')
                  "
                  clearable
                  style="margin-top: 9px"
                ></v-text-field>
              </div>
            </v-col>
            <v-col lg="5" md="5" cols="12">
              <p
                class="title-live mb-2 font-weight-medium grey--text subtitle-2"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.liveStatusFilter'
                  )
                }}
              </p>
              <div class="xs-full-width">
                <v-btn-toggle
                  v-model="canwatch"
                  class="mb-0"
                  color="primary accent-3"
                  background-color="white"
                  mandatory
                  @change="filterCanWacth(canwatch)"
                >
                  <v-btn class="text-capitalize body-2" height="40px">{{
                    $vuetify.lang.t('$vuetify.courseManagement.liveStep.all')
                  }}</v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.waitLive'
                    )
                  }}</v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">{{
                    $vuetify.lang.t('$vuetify.courseManagement.liveStep.live')
                  }}</v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.liveEnd'
                    )
                  }}</v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col lg="4" md="4" cols="12">
              <div align="right" class="pt-lg-6">
                <v-btn
                  @click="initialize"
                  class="pl-5 pr-5 btn-reload body-2"
                  height="40"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>

                <v-btn
                  @click="openLiveDialog(null)"
                  v-on="on"
                  elevation="0"
                  class="
                    font-weight-light
                    button-primary
                    white--text
                    xs-full-width
                    ma-2
                  "
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLive'
                    )
                  }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </div>

      <div
        class="add-course md-fixed-max-width xs-full-max-width xs-full-width"
      ></div>

      <v-data-table
        :loading="loading"
        :headers="headers"
        hide-default-footer
        :items="live.data"
        class="font-weight-light"
        elevation="0"
      >
        <template v-slot:item.title="{ item }"
          ><a @click="openLiveConsoleDialog(item._id)">{{
            item.title
          }}</a></template
        >
        <template v-slot:item.startTime="{ item }"
          >{{ item.startTime | moment('DD/MM/YYYY') }}&nbsp;{{
            new Date(item.startTime).toString().substr(16, 2) + ':'
          }}{{ new Date(item.startTime).toString().substr(19, 2) }}</template
        >
        <template v-slot:item.endTime="{ item }"
          >{{ item.endTime | moment('DD/MM/YYYY') }}&nbsp;{{
            new Date(item.endTime).toString().substr(16, 2) + ':'
          }}{{ new Date(item.endTime).toString().substr(19, 2) }}</template
        >
        <!-- <template v-slot:item.endTime="{ item }">{{ item.endTime | moment("Do MMMM YYYY hh:mm") }}</template> -->
        <template v-slot:item.statusLive="{ item }">
          <!-- <v-icon small class="mr-2" @click="userEdit(item)">mdi-pencil</v-icon> -->
          <!-- <v-btn
          v-if="item.statusLive === true"
          class="my-3 white--text text-uppercase"
          color="error"
          width="150"
        >
          <v-icon left> mdi-access-point </v-icon>
          <p class="mb-0">
            {{ $vuetify.lang.t('$vuetify.courseManagement.liveStep.onLive') }}
          </p>
        </v-btn> -->
          <!-- <v-btn
          v-if="item.statusLive === null"
          class="my-3 white--text button-primary"
          width="150"
        >
          <v-icon left> mdi-video </v-icon>
          <p class="mb-0">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveStarted')
            }}
          </p>
        </v-btn> -->
          <v-chip
            class="ma-2"
            color="red lighten-5"
            label
            text-color="red"
            v-if="item.statusLive == true"
          >
            <v-icon left> mdi-access-point </v-icon>
            <p class="mb-0">
              {{ $vuetify.lang.t('$vuetify.courseManagement.liveStep.onLive') }}
            </p>
          </v-chip>

          <v-chip
            class="ma-2"
            color="grey lighten-5"
            label
            text-color="grey"
            v-if="item.statusLive == false"
          >
            <v-icon left> mdi-access-point </v-icon>
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveEnded')
              }}
            </p>
          </v-chip>

          <v-chip
            class="ma-2"
            color="green lighten-5"
            label
            text-color="green"
            v-if="item.statusLive == null"
          >
            <v-icon left> mdi-video </v-icon>
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.liveStarted'
                )
              }}
            </p>
          </v-chip>
          <!--
        <v-chip
          class="ma-2"
          color="#ff5252"
          text-color="white"
          v-if="item.statusLive === true"
        >
          <div class="flex-grow-1 d-flex align-center justify-center">

            <v-icon left> mdi-access-point </v-icon>
            <p class="mb-0">
              {{ $vuetify.lang.t('$vuetify.courseManagement.liveStep.onLive') }}
            </p>
          </div>
        </v-chip>
        <v-chip
          class="ma-2 max-width-chip"
          color="#429ad8"
          text-color="white"
          v-if="item.statusLive === null"
        >
        <div class="flex-grow-1 d-flex align-center justify-center">
          <v-icon left> mdi-video </v-icon>
          <p class="mb-0">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveStarted')
            }}
          </p>
          </div>
        </v-chip>
        <v-chip
          class="ma-2"
          color="#e0e0e0"
          text-color="#a6a6a6"
          v-if="item.statusLive === false"
        >
        <div class="flex-grow-1 d-flex align-center justify-center">
          <v-icon left> mdi-access-point </v-icon>
          <p class="mb-0">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveEnded')
            }}
          </p>
        </div>
        </v-chip>

-->

          <!-- <v-btn v-if="item.statusLive === false" disabled width="150">
          <v-icon left> mdi-access-point </v-icon>
          <p class="mb-0">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.liveStep.liveEnded')
            }}
          </p>
        </v-btn> -->
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-center">
            <!-- <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="openLiveDialog(item._id)"
          >
            <p class="mb-0">
              {{ $vuetify.lang.t('$vuetify.courseManagement.courseList.edit') }}
            </p>
          </v-btn> -->
            <!-- <v-divider
            v-if="item.statusLive == null"
            inset
            vertical
            class="mb-2 mx-1"
          ></v-divider> -->

            <v-btn
              elevation="0"
              class="mb-0 body-2 text-capitalize text-primary"
              color="white"
              @click="openLiveConsoleDialog(item._id)"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.dashboard'
                  )
                }}
              </p>
            </v-btn>
            <v-divider
              inset
              vertical
              class="mb-2 mx-1"
              v-if="item.statusLive != true"
            ></v-divider>
            <v-btn
              v-if="item.statusLive != true"
              elevation="0"
              class="mb-0 body-2 error--text text-capitalize"
              color="white"
              @click="openDeleteDialog(item._id)"
            >
              <p class="mb-0">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.liveStep.delete')
                }}
              </p>
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="openDeleteDialogStatus" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
            )
          }}</v-card-title>
          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.live.alertDeleteCantBringData'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2 title"
              large
              dark
              outlined
              @click="openDeleteDialogStatus = false"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
              }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 title"
              large
              color="error darken-1"
              dark
              @click="deleteLiveStream"
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="changePage"
          color="rgb(66, 154, 216)"
        ></v-pagination>
      </div>
      <add-live-dialog
        :isOpen.sync="dialog"
        :liveId.sync="liveId"
        :closeDialog="closeLiveDialog"
        :idcourse="params.id"
      ></add-live-dialog>
      <live-console-dialog
        v-if="isLiveConsoleDialogOpen"
        :isLiveConsoleDialogOpen.sync="isLiveConsoleDialogOpen"
        :closeLiveConsoleDialog.sync="closeLiveConsoleDialog"
        :courseId.sync="$route.query.id"
        :liveId.sync="liveId"
      ></live-console-dialog>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import addLiveDialog from '@/components/live/dialog/insertLiveDialog.vue';
import liveConsoleDialog from '@/components/live/live.vue';
import { getLive, deleteLive } from '@/service/course/livev2';
export default {
  components: {
    addLiveDialog,
    liveConsoleDialog,
  },
  data() {
    return {
      live: [],
      dialog: false,
      searchdata: '',
      params: {},
      loading: false,
      liveId: '',
      isLiveConsoleDialogOpen: false,
      selectLive: null,

      page: 1,
      limit: 10,
      pageCount: 0,
      canwatch: 0,
      openDeleteDialogStatus: false,
      deleteId: null,
    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    },
  },

  computed: {
    headers() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.liveName'
          ),
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.startDate'
          ),
          align: 'start',
          sortable: true,
          value: 'startTime',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.endDate'
          ),
          align: 'start',
          sortable: false,
          value: 'endTime',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.liveStatus'
          ),
          align: 'start',
          sortable: false,
          value: 'statusLive',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.liveStep.action'
          ),
          align: 'center',
          sortable: false,
          value: 'action',
        },
      ];
    },
  },

  methods: {
    initialize() {
      this.params = {
        id: this.$route.query.id,
      };
      this.canwatch = 0;
      this.searchdata = null;
      this.getLiveAll();
    },
    openExpand(id) {
      let panel = $('#expand-' + id);
      let btn = $('#centerx-ele-' + id);
      btn.attr('disabled', true);
      if (panel.hasClass('active')) {
        panel.slideUp('slow');
        panel.removeClass('active');
        btn.removeClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      } else {
        panel.slideDown('slow');
        panel.addClass('active');
        btn.addClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      }
    },
    openLiveDialog(id) {
      this.liveId = id;
      this.dialog = true;
    },
    closeLiveDialog() {
      this.dialog = false;
      this.liveId = '';
      this.initialize();
    },
    async changePage(page) {
      this.page = page;
      await this.getLiveAll();
    },
    async filterCanWacth(wacth) {
      this.canwatch = wacth;
      await this.getLiveAll();
    },
    async searchInfo(keyword) {
      this.params.search = keyword;

      await this.getLiveAll();
    },
    async getLiveAll() {
      this.loading = true;
      let data = {};
      let offset = `${(this.page - 1) * this.limit},${this.limit}`;
      if (this.canwatch == 0) {
        data = {
          course: this.$route.query.id,
          // page: this.page,
          // limit: this.limit,
          search: this.params.search,
          filter: 'all',
          offset,
        };
      } else {
        this.page = 1;
        if (this.canwatch == 1) {
          data = {
            course: this.$route.query.id,
            // page: this.page,
            // limit: this.limit,
            search: this.params.search,
            filter: 'created',
            offset,
          };
        } else if (this.canwatch == 2) {
          data = {
            course: this.$route.query.id,
            // page: this.page,
            // limit: this.limit,
            search: this.params.search,
            filter: 'live',
            offset,
          };
        } else if (this.canwatch == 3) {
          data = {
            course: this.$route.query.id,
            // page: this.page,
            // limit: this.limit,
            search: this.params.search,
            filter: 'finished',
            offset,
          };
        } else {
          data = {
            course: this.$route.query.id,
            // page: this.page,
            // limit: this.limit,
            search: this.params.search,
            offset,
          };
        }
      }
      if (this.searchdata && this.searchdata.length > 2) {
        data = {
          ...data,
          search: this.searchdata,
        };
      }
      data = {
        ...data,
        sortBy: 'created_at',
        search: this.params.search,
        sortOrder: -1,
      };
      let result = await getLive(data);
      this.pageCount = result.page;
      this.live = result;
      this.loading = false;
    },

    // Live Console Dialog
    async openLiveConsoleDialog(id) {
      console.log(id);
      // await this.initialize();
      await this.getLiveAll();
      this.liveId = id;
      // this.selectLive = await this.live.data.filter(
      //   (live) => live._id === id
      // )[0];
      this.isLiveConsoleDialogOpen = true;
    },
    async closeLiveConsoleDialog() {
      this.isLiveConsoleDialogOpen = false;
      this.liveId = '';
      try {
        window.jwplayer('video').remove();
      } catch (err) {
        console.log(err);
      }
      // await this.initialize();
      await this.getLiveAll();
    },
    async openDeleteDialog(id) {
      this.deleteId = id;
      this.openDeleteDialogStatus = true;
    },
    async deleteLiveStream() {
      let result = await deleteLive(this.deleteId);
      console.log(result);
      if (!result.code) {
        this.deleteId = null;
        this.openDeleteDialogStatus = false;
        await this.getLiveAll();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}
</style>
<style lang="scss">
.action {
  &:hover {
    text-decoration: underline;
  }
}
.search-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 40px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  height: 40px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 41px;
  text-transform: unset;
  font-weight: normal;
}
.title-live {
  text-transform: uppercase;
}
.v-btn:not(.v-btn--round).v-size--default {
  text-transform: unset;
}
.text-uppercase {
  text-transform: uppercase;
}
.text-capitalize {
  text-transform: capitalize;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>